var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-share_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.444 6.321V7.69h-3.11v10.943h13.333V7.69h-3.111V6.321h2.67c.98 0 1.774.815 1.774 1.817v10.046C16 19.187 15.207 20 14.227 20H1.773C.794 20 0 19.185 0 18.184V8.138C0 7.135.793 6.32 1.773 6.32h2.671zM7.992.001l.1.007a.655.655 0 01.367.18L8.472.2l2.841 2.914a.675.675 0 010 .943l-.012.012a.658.658 0 01-.943 0L8.666 2.335v9.703a.667.667 0 01-1.333 0V2.335l-1.69 1.734a.658.658 0 01-.93.012L4.7 4.07l-.012-.012a.675.675 0 010-.943L7.528.2a.656.656 0 01.464-.198z",
    fill: "#093F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-share_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v20H0z"
  })))));
}

export default SvgIconShare;